import {buildThemes} from '#/alf/themes'

/** Reuse the normal brand palettes; Halloween only changes mode and accent. */
export const halloweenThemes = buildThemes('orange')
